import { NotificationBell } from '@/components/topbar/NotificationBell';
import { EvidenceSyncIndicator } from '@/components/offline/EvidenceSyncIndicator';
import { UserMenu } from './UserMenu';

/**
 * Persistent desktop top bar per
 * `sustevo-handbook/brand/APP_SHELL.md` § 8.
 *
 * Sits above the content area (NOT spanning over the sidebar —
 * sidebar still owns full height). Mobile shell (`<md`) replaces
 * this with `<MobileTopBar />` per § 9.
 *
 * Layout: `flex items-center gap-2` with a leading `flex-1` spacer
 * that pushes the cluster to the right. Optional middle-slot
 * content (breadcrumbs, page title, search trigger) can be added
 * inside the spacer if needed; not required.
 *
 * Right cluster (right-to-left in DOM order):
 *   - <UserMenu />          → avatar dropdown with profile / settings /
 *                             help / sign-out (and optional partner
 *                             switcher block for multi-tenant users)
 *   - <NotificationBell />  → bell with unread badge + 10-item dropdown
 */
export function Topbar(): JSX.Element {
  return (
    <header
      data-testid="topbar"
      // BRAND.md § 3.6 token discipline — chrome reads the canonical ink
      // scale directly (light/dark pair) instead of the shadcn
      // `border-border` / `bg-card` aliases.
      className="hidden h-14 items-center gap-2 border-b border-[var(--color-ink-200)] bg-[var(--color-ink-0)] px-4 dark:border-[var(--color-ink-700)] dark:bg-[var(--color-ink-800)] lg:px-6 md:flex"
    >
      <div className="flex-1" />
      {/* #1476 — offline evidence sync indicator. Renders nothing when the
          queue is empty and the browser is online (zero chrome in the normal
          case), like the connection banner. */}
      <EvidenceSyncIndicator />
      <NotificationBell />
      <UserMenu />
    </header>
  );
}
